module.exports = __webpack_public_path__ + "img/simple-dashboard.fb24c1db.png";